import { render, staticRenderFns } from "./domain_name.vue?vue&type=template&id=622c5036&scoped=true&"
import script from "./domain_name.vue?vue&type=script&lang=js&"
export * from "./domain_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c5036",
  null
  
)

export default component.exports